import CheckExports from '@/views/Export/CheckExports.vue'

const routes = {
  path: '/checkExports',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/checkExports',
      name: 'list-check-export',
      component: CheckExports,
    },
  ],
}

export default routes
